/* =============================================================
   TOUR SPRAY — Cart page interactions
   - Qty steppers + AJAX updates via /cart/change.js
   - Row remove links
   ============================================================= */
(function () {
  'use strict';

  const root = document.querySelector('.tsv2-cart');
  if (!root) return;

  const changeUrl = (window.routes && window.routes.cart_change_url) || '/cart/change.js';

  function debounce(fn, ms) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), ms);
    };
  }

  async function updateLine(line, quantity) {
    try {
      const res = await fetch(changeUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity: parseInt(quantity, 10) }),
      });
      if (!res.ok) throw new Error('cart change failed');
      // Reload to keep prices/totals in sync (simple + reliable)
      window.location.reload();
    } catch (err) {
      console.error('[TourSpray Cart]', err);
    }
  }

  const debouncedUpdate = debounce(updateLine, 350);

  root.querySelectorAll('[data-ts-cart-step]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const line = btn.dataset.line;
      const step = parseInt(btn.dataset.step, 10);
      const input = root.querySelector(`[data-ts-cart-qty][data-line="${line}"]`);
      if (!input) return;
      const next = Math.max(0, (parseInt(input.value, 10) || 1) + step);
      input.value = next;
      updateLine(line, next);
    });
  });

  root.querySelectorAll('[data-ts-cart-qty]').forEach((input) => {
    input.addEventListener('change', () => {
      const line = input.dataset.line;
      const v = Math.max(0, parseInt(input.value, 10) || 0);
      input.value = v;
      debouncedUpdate(line, v);
    });
  });

  root.querySelectorAll('[data-ts-cart-remove]').forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const line = link.dataset.line;
      updateLine(line, 0);
    });
  });

  /* Reveal fallback */
  const revealables = root.querySelectorAll('.tsv2-reveal');
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) { e.target.classList.add('is-revealed'); io.unobserve(e.target); }
      });
    }, { threshold: 0.1 });
    revealables.forEach((el) => io.observe(el));
  } else {
    revealables.forEach((el) => el.classList.add('is-revealed'));
  }
})();
